import axios from 'axios';

// Configure axios defaults with environment-based API URL
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5002',
  timeout: 10000, // 10 seconds timeout
  withCredentials: true // Send cookies with cross-domain requests
});

// Add request interceptor for auth token
instance.interceptors.request.use(
  (config) => {
    // Log request details during development
    console.log(`API Request: ${config.method?.toUpperCase()} ${config.baseURL}${config.url}`);
    
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers['x-auth-token'] = token;
    }
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Track redirect to avoid multiple navigations
let isRedirectingForAuth = false;

// Add response interceptor for better error handling
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error('API Error Response:', {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data,
        headers: error.response.headers,
        url: error.config.url,
        method: error.config.method
      });
      // Auto-handle unauthorized responses
      if (error.response.status === 401 && !isRedirectingForAuth) {
        try {
          isRedirectingForAuth = true;
          // Clear stored token and axios headers
          localStorage.removeItem('token');
          delete instance.defaults.headers.common['Authorization'];
          delete instance.defaults.headers.common['x-auth-token'];
        } catch {}
        // Redirect to login page
        if (typeof window !== 'undefined') {
          const current = window.location.pathname + window.location.search;
          const target = '/login';
          // Preserve return path
          const redirectUrl = current && current !== '/login' ? `${target}?next=${encodeURIComponent(current)}` : target;
          window.location.assign(redirectUrl);
        }
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('API No Response Error:', {
        request: error.request,
        url: error.config.url,
        method: error.config.method
      });
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('API Config Error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

export default instance;
